var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menu_drawer__wrapper" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "menu_drawer" }, [
        _c(
          "ul",
          { staticClass: "menu_drawer__list" },
          _vm._l(_vm.menu, function(item) {
            return _c(
              "li",
              { key: item.ID, staticClass: "menu_drawer__item" },
              [
                _c("a", { attrs: { href: item.url } }, [
                  _vm._v(_vm._s(item.title))
                ])
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "menu_drawer__copyright" }, [
        _c("span", [_vm._v("© " + _vm._s(_vm.year) + " All rights reserved")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "menu_drawer__social_links" }, [
        _c(
          "a",
          { attrs: { href: _vm.socialLinks.twitter, target: "_blank" } },
          [_c("i", { staticClass: "fa fa-twitter" })]
        ),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.socialLinks.facebook, target: "_blank" } },
          [_c("i", { staticClass: "fa fa-facebook" })]
        ),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.socialLinks.instagram, target: "_blank" } },
          [_c("i", { staticClass: "fa fa-instagram" })]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-449ea41b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /var/www/costimise/wp-content/themes/costimise/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-449ea41b","hasScoped":true,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!/var/www/costimise/wp-content/themes/costimise/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/burger-menu/BurgerMenuDrawer.vue
// module id = 121
// module chunks = 0